<template>
  <el-select v-model="currentValue" :class="selectClass" :disabled="disabled" :clearable="clearable"
    :filterable="remote" :remote="remote" :placeholder="placeholder || (remote ? '请输入拼音码查询' : '请选择')" :loading="loading"
    :remote-method="remoteMethod" @change="onChange" @clear="onClear">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import { getRequest } from "@/api/matrixApi";

export default {
  name: "matrix-select",
  props: {
    value: [String, Number, Boolean],
    placeholder: String,
    // 表单字段名
    keys: String,
    // 是否可清空
    clearable: {
      type: Boolean,
      default: true,
    },
    // 字典 code
    code: String,
    // 自定义查询参数
    customParam: String,
    // 是否开启远程搜索
    remote: Boolean,
    // 拼音码 type
    type: String,
    // 自定义 url 地址
    customUrl: String,
    disabled: Boolean,
    // selectClass
    selectClass: {
      type: String,
      default: "defSelectClass",
    },
    // customConfig { value: 'dictKey', label: 'dictValue' }
    customConfig: Object,
    // 自定义 options (传入后不再查询接口)
    customOptions: Array,
    // 是否需要添加'全部'选项
    needAll: Boolean,
  },
  model: {
    event: "onSelect",
  },
  data() {
    return {
      options: [],
      list: [],
      loading: false,
      currentValue: undefined,
      url: {
        dic: "/",
        remote: "/",
      },
      defaultConfig: {
        value: this.remote ? "code" : "dictKey",
        label: this.remote ? "name" : "dictValue",
      },
    };
  },
  created() {
    if (!this.remote && !this.customOptions) {
      this.getOptions();
    } else if (this.customOptions) {
      this.initOptions(this.customOptions);
    }
  },
  watch: {
    value: {
      handler(val) {
        this.currentValue = val.toString();
      },
      immediate: true,
    },
  },
  methods: {
    // 获取字典数据
    getOptions() {
      const url = this.customUrl ? this.customUrl : this.url.dic;
      const result = this.customParam ? this.customParam : { code: this.code };
      getRequest(url, result).then((res) => {
        const data = Array.isArray(res.data) ? res.data : res.data.data;
        const list = this.deepClone(data);
        this.initOptions(list);
      });
    },
    // 获取拼音码数据
    remoteMethod(key) {
      this.loading = true;
      const url = this.customUrl ? this.customUrl : this.url.remote;
      getRequest(url, { type: this.type, sortl: key })
        .then((res) => {
          const list = this.deepClone(res.data.data);
          this.initOptions(list);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initOptions(list) {
      const arr = this.deepClone(list);
      const valueKey = this.customConfig.value || this.defaultConfig.value;
      const labelKey = this.customConfig.label || this.defaultConfig.label;
      if (this.needAll) arr.unshift({ [valueKey]: "", [labelKey]: "全部" });
      this.options = arr.map((item) => ({
        value: item[valueKey],
        label: item[labelKey],
      }));
      this.currentValue = this.value.toString();

    },
    onChange(val) {
      this.$emit("onSelect", val);
    },
    onClear(val) {
      this.$emit("onSelect", val);
    },
  },
};
</script>

<style scoped>
.defSelectClass {
  width: 100%;
}
</style>
